import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    search_text: "",
  },
};

const vendorSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = initialState.filters;
    },
  },
});

export const { setFilters, resetFilters } = vendorSlice.actions;
export default vendorSlice.reducer;
